import { useAtom, useAtomValue } from 'jotai';

import { isPaletteOpenedSelector, openedPaletteAtom } from '../state';
import { PaletteMenuRoot } from './PaletteMenu';

/**
 * Singleton component to render the current palette.
 */
export function Palette() {
    const [visiblePalette, setVisiblePalette] = useAtom(openedPaletteAtom);

    return (
        <PaletteMenuRoot
            visiblePalette={visiblePalette}
            onVisiblePaletteChange={setVisiblePalette}
        />
    );
}

export function useIsPaletteOpened() {
    return useAtomValue(isPaletteOpenedSelector);
}
